/*
 * @Author: Huangxianlong
 * @Date: 2023-08-14 11:43:48
 * @LastEditors: Huangxianlong
 * @LastEditTime: 2023-08-14 11:49:43
 * @FilePath: \monitor\src\language\data\latest.js
 * @Description: 
 */
const info = {
  CN: {
    project: "项目",
    zone: "区域",
    collector: "采集器",
    sensor: "传感器",
    normal: "正常",
    warn: "预警",
    dangerous: "危险",
    maximum: "最大值"
  },
  EN: {
    project: "Project",
    zone: "Zone",
    collector: "Collector",
    sensor: "Sensor",
    normal: "Normal",
    warn: "Warn",
    dangerous: "Dangerous",
    maximum: "Maximum value"
  }
};
export default info; //需要暴露出去



// WEBPACK FOOTER //
// ./src/language/data/latest.js